export default __webpack_public_path__ + "static/media/de.11d88d2b.svg";